<template>
  <div class="ordinaryModify custom">
    <el-dialog :popper-append-to-body="false" :close-on-click-modal="false" :visible.sync="plainGoldSelectDialogVisible" :before-close="handleClose">
      <div
        class="ordinaryModifyChild"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div class="secBox">
          <div class="child" v-if="showSettlementMethod && settlementMethodList && settlementMethodList.length > 0">
            <div class="selb">
              <span class="selb-title">结算方式：</span>
              <div class="material selectBox">
                <el-radio-group v-model="amendDuplication.settlementMethod" size="small" @change="getSizeRange($event, 'settlementMethod')">
                  <span class="inchesFix">
                    <el-radio-button
                      v-for="item in settlementMethodList"
                      :key="item.value"
                      :value="item.value"
                      :label="item.value"
                      :disabled="item.disabled"
                    >
                      {{ item.label }}
                    </el-radio-button>
                  </span>
                </el-radio-group>
              </div>
            </div>
          </div>

          <div class="child" v-if="formatTypes && formatTypes.length > 0">
            <div class="selb">
              <span class="selb-title">版型：</span>
              <div class="material selectBox">
                <el-radio-group v-model="amendDuplication.formatType" size="small" @change="getSizeRange($event, 'formatType')">
                  <span class="inchesFix">
                    <el-radio-button v-for="item in formatTypes" :key="item" :value="item" :label="item">
                      {{ item }}
                    </el-radio-button>
                  </span>
                </el-radio-group>
              </div>
            </div>
          </div>

          <div class="child" v-if="lcTechnologList && lcTechnologList.length > 0">
            <div class="selb">
              <span class="selb-title">鎏彩工艺：</span>
              <div class="material selectBox">
                <el-radio-group v-model="amendDuplication.lcTechnology" size="small" @change="getSizeRange($event, 'lcTechnology')">
                  <span class="inchesFix">
                    <el-radio-button v-for="item in lcTechnologList" :key="item" :value="item" :label="item">
                      {{ item }}
                    </el-radio-button>
                  </span>
                </el-radio-group>
              </div>
            </div>
          </div>

          <div class="child" v-if="goldenWeighList && goldenWeighList.length > 0">
            <div class="selb">
              <span class="selb-title">金重：</span>
              <div class="material selectBox">
                <el-radio-group v-model="amendDuplication.goldWeigh" size="small" @change="getSizeRange($event, 'goldWeigh')">
                  <span class="inchesFix">
                    <el-radio-button v-for="item in goldenWeighList" :key="item" :value="item" :label="item">
                      {{ item }}
                    </el-radio-button>
                  </span>
                </el-radio-group>
              </div>
            </div>
          </div>

          <div class="child" v-if="handSizeList && handSizeList.length > 0">
            <div class="selb">
              <span class="inchesTips-size" v-if="handSizeList && handSizeList[0].includes('寸')"> (1英寸＝2.54厘米) </span>
              <span class="selb-title">规格：</span>
              <div class="material selectBox">
                <el-radio-group v-model="amendDuplication.ringSize" size="small" @change="getSizeRange($event, 'ringSize')">
                  <span class="inchesFix">
                    <el-radio-button v-for="item in handSizeList" :key="item" :value="item" :label="item">
                      {{ item }}
                    </el-radio-button>
                  </span>
                </el-radio-group>
              </div>
            </div>
          </div>

          <div class="child">
            <div class="selb">
              <span class="selb-title">商品数量：</span>
              <el-input-number
                :min="amendDuplication.spotFlag == 1 ? 1 : product.leastQuantity"
                :max="amendDuplication.spotFlag == 2 ? 9999 : optionsList.stockQuantity"
                v-model="amendDuplication.quantity"
                @change="getSizeRange($event, 'quantity')"
              ></el-input-number>
              <span class="inchesTips" v-if="amendDuplication.spotFlag == 1"> 库存：{{ optionsList.stockQuantity || 0 }}件 </span>
            </div>
          </div>

          <div class="child remorkBox">
            <div class="selb">
              <span class="selb-title">备注：</span>
              <el-input type="textarea" :autosize="{ minRows: 3 }" placeholder="请输入内容" v-model="amendDuplication.productRemark"> </el-input>
            </div>
          </div>

          <div class="child" v-if="settlementWeight && amendDuplication.settlementMethod == 2">
            <div class="selb">
              <span class="selb-title">结算金重：</span>
              <span>{{ settlementWeight }}</span>
            </div>
          </div>

          <div class="child" v-if="tradePrice && hasPriceViewPermission()">
            <div class="selb">
              <span class="selb-title"> {{ amendDuplication.settlementMethod == 2 ? '结算工费' : '结算金额' }}： </span>
              <span>{{ tradePrice }}</span>
            </div>
          </div>

          <div class="child" v-if="labelPrice && (!amendDuplication.exclusivePrice || amendDuplication.exclusivePrice == 0)">
            <div class="selb">
              <span class="selb-title">标签价格：</span>
              <span>{{ labelPrice }}</span>
            </div>
          </div>

          <div class="child" v-if="amendDuplication.exclusivePrice && amendDuplication.exclusivePrice != 0 && amendDuplication.settlementMethod != 2">
            <div class="selb">
              <span class="selb-title">尊享价格：</span>
              <span>{{ amendDuplication.exclusivePrice }}</span>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="btnFlag" class="modifyCart" @click.stop="updateCpoyCart('修改')"> 确定修改 </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getOptional, getPriceRangeSpot } from '@/api/detailsApi';
import { modifyCartPublic } from '@/api/cartApi';
import { deepClone } from '@/utils/util';
import { debounce } from '@/utils/index';
import ls from '@/utils/localStorage';
import { Decimal } from 'decimal.js';

export default {
  props: {
    plainGoldSelectDialogVisible: Boolean,
    modifyingReplication: {
      type: Object,
      default() {
        return {};
      },
    },
    product: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      optionsList: {},
      amendDuplication: {
        settlementMethod: '',
        formatType: '',
        lcTechnology: '',
        goldWeigh: '',
        ringSize: '',
        tradePrice: '',
        labelPrice: '',
        exclusivePrice: '',
      },
      btnFlag: false,
      formatTypes: [],
      goldenWeighList: [],
      handSizeList: [],
      lcTechnologList: [],
      lcTechnologyIndex: 0,
      goldWeighIndex: 0,
      tradePrice: '',
      labelPrice: '',
      loading: false,
      settlementMethodList: [
        { label: '结 料', value: 2 },
        { label: '结 价', value: 1 },
      ],
      settlementWeight: 0,
    };
  },
  computed: {
    showSettlementMethod() {
      const displayFlag = this.optionsList.factorySource != '1';
      return displayFlag;
    },
  },
  mounted() {
    this.amendDuplication = {
      ...this.amendDuplication,
      ...deepClone(this.modifyingReplication),
    };
    this.getOptional();
  },
  methods: {
    mainStoneSort(list) {
      const parsedRanges = list?.map((range) => {
        const [start, end] = range.split('-').map(parseFloat);
        return { start, end, range };
      });
      parsedRanges.sort((a, b) => a.start - b.start);
      return parsedRanges.map((item) => item.range);
    },
    sortFun(handSizeList) {
      return handSizeList?.sort(function (a, b) {
        return a - b;
      });
    },
    hasCurrentLcTechnology() {
      if (this.amendDuplication.spotFlag == 2) {
        return this.optionsList.lcTechnologyFlag == 1;
      }
      return (
        (this.amendDuplication.settlementMethod == 2 && this.optionsList.materLcTechnologyFlag == 1) ||
        (this.amendDuplication.settlementMethod == 1 && this.optionsList.lcTechnologyFlag == 1)
      );
    },
    getMapFirstValue(map) {
      return Object.values(map || {}).find((item) => item !== undefined && item !== null);
    },
    isPlainObject(value) {
      return Object.prototype.toString.call(value) === '[object Object]';
    },
    hasCurrentFormatType(currentOptionalMap) {
      if (this.optionsList.formatTypeFlag != 1) return false;

      const firstValue = this.getMapFirstValue(currentOptionalMap);
      if (!this.isPlainObject(firstValue)) return false;

      const nestedValue = this.getMapFirstValue(firstValue);
      if (this.hasCurrentLcTechnology()) {
        return this.isPlainObject(nestedValue);
      }

      return Array.isArray(nestedValue);
    },
    getCurrentOptionalMap() {
      if (this.amendDuplication.spotFlag == 2) {
        if (this.amendDuplication.isCouples == 2) {
          return this.optionsList.handSizeMap || {};
        }
        return this.optionsList.couplesMap?.[this.amendDuplication.gender] || {};
      }

      if (this.amendDuplication.isCouples == 2) {
        if (this.amendDuplication.settlementMethod == 2 && this.optionsList.materLcTechnologyFlag == 1) {
          return this.optionsList.materHandSizeMap || {};
        }
        if (this.amendDuplication.settlementMethod == 1 && this.optionsList.lcTechnologyFlag == 1) {
          return this.optionsList.handSizeMap || {};
        }
        return this.amendDuplication.settlementMethod == 2 && this.amendDuplication.spotFlag == 1
          ? this.optionsList.materHandSizeMap || {}
          : this.optionsList.handSizeMap || {};
      }

      if (this.amendDuplication.settlementMethod == 2 && this.optionsList.materLcTechnologyFlag == 1) {
        return this.optionsList.materCouplesMap?.[this.amendDuplication.gender] || {};
      }
      if (this.amendDuplication.settlementMethod == 1 && this.optionsList.lcTechnologyFlag == 1) {
        return this.optionsList.couplesMap?.[this.amendDuplication.gender] || {};
      }
      return this.amendDuplication.settlementMethod == 1 || this.amendDuplication.spotFlag == 2
        ? this.optionsList.couplesMap?.[this.amendDuplication.gender] || {}
        : this.optionsList.materCouplesMap?.[this.amendDuplication.gender] || {};
    },
    pickCurrentValue(list, value) {
      return list.includes(value) ? value : list[0] || '';
    },
    normalizeGoldWeighValue(list, value) {
      if (!value) return '';
      if (list.includes(value)) return value;

      const compareValue = value.includes('-') ? Number(value.split('-')[0]) : Number(value);
      if (Number.isNaN(compareValue)) return value;

      for (const item of list) {
        if (!item?.includes('-')) continue;
        const [start, end] = item.split('-').map(Number);
        if (start <= compareValue && end >= compareValue) {
          return item;
        }
      }

      return value;
    },
    assembleOptionalData() {
      const currentOptionalMap = this.getCurrentOptionalMap();
      const hasFormatType = this.hasCurrentFormatType(currentOptionalMap);
      const hasLcTechnology = this.hasCurrentLcTechnology();

      this.formatTypes = hasFormatType ? Object.keys(currentOptionalMap) : [];
      if (!hasFormatType || !this.formatTypes.includes(this.amendDuplication.formatType)) {
        this.amendDuplication.formatType = '';
      }

      const currentFormatType = hasFormatType ? this.pickCurrentValue(this.formatTypes, this.amendDuplication.formatType) : '';
      const currentFormatMap = hasFormatType ? currentOptionalMap[currentFormatType] || {} : currentOptionalMap;

      if (hasLcTechnology) {
        this.lcTechnologList = Object.keys(currentFormatMap);
        if (!this.lcTechnologList.includes(this.amendDuplication.lcTechnology)) {
          this.amendDuplication.lcTechnology = '';
        }

        const currentLcTechnology = this.pickCurrentValue(this.lcTechnologList, this.amendDuplication.lcTechnology);
        const currentLcTechnologyMap = currentFormatMap[currentLcTechnology] || {};
        const goldenWeighList = this.mainStoneSort(Object.keys(currentLcTechnologyMap));
        const normalizedGoldWeigh = this.normalizeGoldWeighValue(goldenWeighList, this.amendDuplication.goldWeigh);
        if (normalizedGoldWeigh && normalizedGoldWeigh !== this.amendDuplication.goldWeigh) {
          this.amendDuplication.goldWeigh = normalizedGoldWeigh;
        } else if (!goldenWeighList.includes(this.amendDuplication.goldWeigh)) {
          this.amendDuplication.goldWeigh = '';
        }

        const currentGoldWeigh = this.pickCurrentValue(goldenWeighList, this.amendDuplication.goldWeigh);
        this.lcTechnologyIndex = this.lcTechnologList.indexOf(currentLcTechnology);
        this.goldWeighIndex = goldenWeighList.indexOf(currentGoldWeigh);
        this.goldenWeighList = goldenWeighList;
        this.handSizeList = this.sortFun(
          currentGoldWeigh ? currentLcTechnologyMap[currentGoldWeigh] || [] : Object.values(currentLcTechnologyMap)[0] || [],
        );
      } else {
        this.amendDuplication.lcTechnology = '';
        const goldenWeighList = this.mainStoneSort(Object.keys(currentFormatMap));
        const normalizedGoldWeigh = this.normalizeGoldWeighValue(goldenWeighList, this.amendDuplication.goldWeigh);
        if (normalizedGoldWeigh && normalizedGoldWeigh !== this.amendDuplication.goldWeigh) {
          this.amendDuplication.goldWeigh = normalizedGoldWeigh;
        } else if (!goldenWeighList.includes(this.amendDuplication.goldWeigh)) {
          this.amendDuplication.goldWeigh = '';
        }

        const currentGoldWeigh = this.pickCurrentValue(goldenWeighList, this.amendDuplication.goldWeigh);
        this.lcTechnologList = [];
        this.lcTechnologyIndex = 0;
        this.goldWeighIndex = goldenWeighList.indexOf(currentGoldWeigh);
        this.goldenWeighList = goldenWeighList;
        this.handSizeList = this.sortFun(currentGoldWeigh ? currentFormatMap[currentGoldWeigh] || [] : Object.values(currentFormatMap)[0] || []);
      }

      if (!this.handSizeList.includes(this.amendDuplication.ringSize)) {
        this.amendDuplication.ringSize = '';
      }
    },
    getOptional() {
      const obj = {
        styleNumber: this.amendDuplication.styleNumber,
        gender: this.amendDuplication.gender,
        classify: this.amendDuplication.classify,
        spotFlag: this.amendDuplication.spotFlag,
        cartId: this.amendDuplication.id,
        requestFrom: 1,
        sequence: this.amendDuplication.sequence,
      };
      getOptional(obj).then((res) => {
        this.optionsList = { ...this.optionsList, ...res.data };
        if (this.optionsList.formatTypeFlag == 1 && !this.amendDuplication.formatType) {
          this.amendDuplication.formatType = '无版式';
        }
        this.settlementMethodList.forEach((item) => {
          item.disabled = false;
          if (
            (!this.optionsList.materStockQuantity || this.optionsList.materStockQuantity <= 0) &&
            item.value == 2 &&
            this.amendDuplication.spotFlag == 1
          ) {
            item.disabled = true;
          } else if (this.optionsList.stockQuantity <= 0 && item.value == 1 && this.amendDuplication.spotFlag == 1) {
            item.disabled = true;
          }
        });
        this.optionsList.stockQuantity = 0;
        this.assembleOptionalData();
        this.defaultSelected();
        this.getPriceRange();
      });
    },
    defaultSelected() {
      if (this.formatTypes.length == 1) {
        this.amendDuplication.formatType = this.formatTypes[0];
      }
      if (this.hasCurrentLcTechnology()) {
        if (this.lcTechnologList.length == 1) {
          this.amendDuplication.lcTechnology = this.lcTechnologList[0];
        }
        if (this.goldenWeighList.length == 1) {
          this.amendDuplication.goldWeigh = this.goldenWeighList[0];
        }
        if (this.handSizeList.length == 1) {
          this.amendDuplication.ringSize = this.handSizeList[0];
        }
      } else {
        if (this.goldenWeighList.length == 1) {
          this.amendDuplication.goldWeigh = this.goldenWeighList[0];
        }
        if (this.handSizeList.length == 1) {
          this.amendDuplication.ringSize = this.handSizeList[0];
        }
      }
    },
    getSizeRange(value, type) {
      this.amendDuplication[type] = value;

      if (type === 'settlementMethod') {
        this.amendDuplication.formatType = '';
        this.amendDuplication.lcTechnology = '';
        this.amendDuplication.goldWeigh = '';
        this.amendDuplication.ringSize = '';
        this.lcTechnologyIndex = 0;
      }
      if (type === 'formatType') {
        this.amendDuplication.lcTechnology = '';
        this.amendDuplication.goldWeigh = '';
        this.amendDuplication.ringSize = '';
        this.lcTechnologyIndex = 0;
      }
      if (type === 'lcTechnology') {
        this.amendDuplication.goldWeigh = '';
        this.amendDuplication.ringSize = '';
      }
      if (type === 'goldWeigh') {
        this.amendDuplication.ringSize = '';
      }

      if (['settlementMethod', 'formatType', 'lcTechnology', 'goldWeigh'].includes(type)) {
        this.assembleOptionalData();
        this.defaultSelected();
        this.getPriceRange();
        return;
      }

      this.defaultSelected();
      this.getPriceRange();
    },
    updateCpoyCart(text) {
      let type = '';
      let obj = {};
      if (this.handSizeList.length > 0 && !this.amendDuplication.ringSize) {
        return this.$message({
          message: '请选择规格',
          type: 'warning',
          duration: 500,
        });
      }
      if (!this.amendDuplication.quantity) {
        return this.$message({
          message: '数量不能为0',
          type: 'warning',
          duration: 500,
        });
      }
      if (text === '修改') {
        type = 'put';
      } else {
        obj = {
          productDtoList: [this.amendDuplication],
          shopType: 2,
          type: 2,
          orderPath: 1,
          requestFrom: 1,
          spotFlag: this.amendDuplication.spotFlag,
          purchaseSource: ls.get('coludQuery') ? 0 : 1,
          siteId: ls.get('siteId') || ls.get('userInfo').sysUser?.siteId || '',
        };
        type = 'post';
      }
      modifyCartPublic(text === '修改' ? this.amendDuplication : obj, type).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: text === '修改' ? '修改成功' : '复制成功',
            type: 'success',
            duration: 1500,
          });
          this.$emit('updataCart');
          this.$emit('onCloseSelectDialog');
        }
      });
    },
    onNative: debounce(
      function (event) {
        if (Number(event.target.value)) {
          if (this.amendDuplication.spotFlag == 2 && event.target.value > 9999) {
            this.amendDuplication.quantity = 9999;
          } else if (this.amendDuplication.spotFlag == 1 && event.target.value > this.optionsList.stockQuantity) {
            this.amendDuplication.quantity = this.optionsList.stockQuantity;
          }
        }
      },
      500,
      true,
    ),
    getPriceRange() {
      const obj = deepClone(this.amendDuplication);
      // 存在版型选项时，必须已选择版型
      // if (this.formatTypes && this.formatTypes.length > 0) {
      //   if (!obj.formatType) return;
      // } else {
      //   // 不存在版型选项时，必须已选择金重
      //   if (!obj.goldWeigh) return;
      // }
      delete obj.texture;
      getPriceRangeSpot(obj)
        .then((res) => {
          this.$nextTick(() => {
            if (obj.goldWeigh) {
              if (obj.goldWeigh?.includes('-')) {
                this.settlementWeight = new Decimal(obj.goldWeigh.split('-')[1]).mul(obj.quantity).toFixed(2);
              } else {
                this.settlementWeight = new Decimal(obj.goldWeigh).mul(obj.quantity).toFixed(2);
              }
            } else this.settlementWeight = 0;
            this.tradePrice = res.data.tradePrice;
            this.labelPrice = res.data.labelPrice;
            this.amendDuplication.tradePrice = res.data.tradePrice;
            this.amendDuplication.labelPrice = res.data.labelPrice;
            this.amendDuplication.exclusivePrice = res.data.exclusivePrice;
            this.optionsList.stockQuantity = res.data.stockQuantity;
          });
        })
        .catch(() => {});
    },
    handleClose() {
      this.$emit('onCloseSelectDialog');
    },
  },
};
</script>

<style scoped lang="scss">
.ordinaryModify {
  ::v-deep .el-dialog {
    width: 900px;
  }

  ::v-deep .el-dialog__body {
    padding-top: 0;
  }

  .ordinaryModifyChild {
    display: flex;
  }

  ::v-deep .el-select > .el-input {
    width: 300px;
  }

  .secBox {
    width: 100%;
  }

  .remorkBox {
    margin-top: 25px !important;
  }

  .child {
    display: flex;
    justify-content: space-between;
    margin: 10px 0;

    .selb {
      display: flex;
      align-items: center;
      position: relative;

      ::v-deep .el-radio__input.is-checked .el-radio__inner {
        border-color: #ec9368;
        background: #ec9368;
      }

      ::v-deep .el-radio__input.is-checked + .el-radio__label {
        color: #ec9368;
      }

      span {
        font-size: 14px;
        display: inline-block;
        margin-right: 5px;
        min-width: 70px;
      }

      .selb-title {
        text-align: right;
      }
    }
  }

  ::v-deep .el-dialog__headerbtn .el-dialog__close {
    font-size: 24px;
  }

  ::v-deep .el-dialog__headerbtn {
    top: 5px;
    right: 5px;
  }
}

::v-deep .el-select-dropdown__item {
  padding: 0;
  height: auto;
}

::v-deep .el-select-dropdown__list {
  display: flex;
  width: 300px;
  flex-wrap: wrap;
}

::v-deep .el-input__inner {
  color: #ec9368;
}

::v-deep .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: #fff;
}

::v-deep .el-input-number {
  width: 300px;
}

::v-deep .el-icon-minus {
  font-size: 14px;
  color: #ec9368;
}

::v-deep .el-icon-plus {
  font-size: 14px;
  color: #ec9368;
}

::v-deep .el-textarea__inner {
  width: 760px;
}

::v-deep .el-dialog__footer {
  text-align: center;
}

::v-deep .el-button span {
  font-size: 14px;
}

.modifyCart {
  background: #87ceeb;
  color: #fff;
  border: none;
}

.copyCart {
  background: #ec9368;
  color: #fff;
  border: none;
  margin-left: 20px;
}

.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  color: #c0c4cc;
  cursor: not-allowed;
  background-image: none;
  background-color: #fff;
  border: 1px solid #ebeef5;
}

.custom {
  .fx {
    position: relative;
    margin: 8px 0;
  }

  .fl {
    display: flex;
    align-items: center;
    position: relative;
  }

  .selectBox {
    ::v-deep .el-popper {
      left: 0 !important;
    }

    .el-scrollbar__view li {
      width: 178px;
    }
  }

  .selectBoxWatch {
    .el-scrollbar__view li {
      min-width: 90px;
    }
  }

  .inchesFix {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  .inchesTips {
    color: red;
    font-size: 12px;
    margin-left: 8px;
  }

  .inchesTips-size {
    color: red;
    font-size: 12px !important;
    margin-left: 8px;
    position: absolute;
    top: 37px;
    left: 20px;
  }

  .material {
    ::v-deep .el-radio-button__inner {
      min-width: 65px;
    }
  }

  ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #fff;
    background-color: #ec9368;
    border-color: #ec9368;
    box-shadow: none;
  }

  ::v-deep .el-radio-button__inner:hover {
    color: rgb(236, 147, 104);
  }

  ::v-deep .el-radio-button__inner {
    margin: 5px;
    border-left: 1px solid #dcdfe6;
    border-radius: 4px;
  }

  ::v-deep .inchesFix:first-child .el-radio-button__inner {
    margin-left: 0;
  }

  ::v-deep .el-radio-group {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
